import { render } from "./SideLeft.vue?vue&type=template&id=52ba83c6&scoped=true"
import script from "./SideLeft.vue?vue&type=script&lang=js"
export * from "./SideLeft.vue?vue&type=script&lang=js"

import "./SideLeft.vue?vue&type=style&index=0&id=52ba83c6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ba83c6"]])

export default __exports__